import { useMemo } from 'react';

import { useFishGroupsController_getDetail } from '@/services/hooks';
import type { FishGroupDetailDto } from '@/services/types';

import type { DomainQueryOptions } from '../shared/types';

import { mapFishGroupDetailToDomain } from './mappers';
import type { UseGetFishGroupDetailResult } from './types';

export const useGetFishGroupDetail = (
    clientId: number,
    fishGroupId: number,
    options?: DomainQueryOptions<FishGroupDetailDto>
): UseGetFishGroupDetailResult => {
    const query = useFishGroupsController_getDetail(clientId, fishGroupId, options);

    const detail = useMemo(() => {
        if (!query.data?.data) return null;
        return mapFishGroupDetailToDomain(query.data.data);
    }, [query.data?.data]);

    return {
        data: detail,
        isLoading: query.isPending,
        isFetching: query.isFetching,
        isFetched: query.isFetched,
        error: query.error,
        refetch: query.refetch,
    };
};
